(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["royal-coffee-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const faqHash = '#royal-coffee-faq';

    const scrollToFaq = () => {
      if (window.location.hash !== faqHash) return;

      const faq = document.querySelector(faqHash);
      if (!faq) return;

      const header = document.querySelector('.header-section');
      const headerOffset = header ? header.getBoundingClientRect().height + 12 : 12;
      const faqTop = faq.getBoundingClientRect().top + window.scrollY - headerOffset;

      window.scrollTo({
        top: Math.max(0, faqTop),
        behavior: 'auto',
      });
    };

    const scheduleFaqScroll = () => {
      requestAnimationFrame(() => requestAnimationFrame(scrollToFaq));
      window.setTimeout(scrollToFaq, 300);
      window.setTimeout(scrollToFaq, 1000);
    };

    if (document.readyState === 'complete') {
      scheduleFaqScroll();
    } else {
      window.addEventListener('load', scheduleFaqScroll, { once: true });
    }

    window.addEventListener('hashchange', scheduleFaqScroll);
  })();

  } catch(e) { console.error(e); }
})();
})();
